import { styled, Typography, TypographyProps as MuiTypographyProps } from "@mui/material";

interface TypographyProps {
  colors: [string, string];
}

type StyledTypographyProps = MuiTypographyProps & TypographyProps;

const StyledTypography = styled(Typography)<StyledTypographyProps>(({ colors, ...props }) => ({
  letterSpacing: "-0.02em",
  background: `linear-gradient(to bottom right, ${colors[0]}, ${colors[1]})`,
  backgroundClip: "text",
  color: "transparent",
}));

export default StyledTypography;
